import styled from 'styled-components';
import { defaultShadow } from '../../styles/global';

export interface CardContainerProps {
  background?: string;
}

export const CardContainer = styled.div<CardContainerProps>`
  color: ${(p) => p.theme.colors.onSurface};

  flex: 1;
  height: 6rem;
  min-width: 90%;
  display: flex;

  margin: 1rem;
  border: none;
  border-radius: 0.75rem;

  ${defaultShadow}
  font-weight: 600;

  @media (min-width: 500px) {
    min-width: 200px;
  }

  &::before {
    content: '';
    width: 10px;
    background: ${(p) => p.background};
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .card-icon-1354 {
    background-color: ${(p) => p.background}50;
    width: 4rem;
    height: 4rem;

    margin: auto;
    margin-left: 1rem;
    margin-right: 1rem;
    border-radius: 0.5rem;

    display: flex;
    justify-content: center;
    align-items: center;

    & svg {
      color: ${(p) => p.background};
      size: 50px;
      font-size: 2rem;
    }
  }

  .card-info-1354 {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;

    width: 60%;
    max-height: 100%;

    margin: 1rem;
    margin-top: 1rem;
    box-sizing: border-box;

    > * {
      flex: 1;
      width: 100%;
    }

    .card-info-value-1354 {
      font-weight: bold;
      font-size: 1.3rem;
      display: flex;
      align-items: center;
    }
  }
`;

export default CardContainer;
